import Resource from 'Resources/Resource';

type ColumnSuggestionRequest = {
	type: string;
	columns: { name: string; sampleValues: string[] }[];
	fields: { tag: string; name: string; description?: string }[];
};

/** A field the server suggests for a file column, found from an earlier import, the field's own name or AI. */
export type ColumnSuggestion = { name: string; field: string };

class Import extends Resource {
	status = {
		DRAFT: 'DRAFT',
		START: 'START',
		STARTED: 'STARTED',
		FINISHED: 'FINISHED'
	};

	type = {
		CLIENT_AND_CONTACT: 'CLIENT_AND_CONTACT',
		PRODUCT: 'PRODUCT',
		ORDER: 'ORDER'
	};

	constructor() {
		super('imports');
	}

	suggestColumns(body: ColumnSuggestionRequest): Promise<ColumnSuggestion[]> {
		return this._postRequest('column-suggestions', body, { methodName: 'suggestColumns' }).then(
			(res: { data: { data: ColumnSuggestion[] } }) => res.data.data
		);
	}
}

const resource = new Import();

export default resource;
